module.exports = __webpack_public_path__ + "img/add.a6a5da05.png";